<template>
  <main-template>
    <v-row>
      <v-col>
        <span class="text-h4">Feedback Coordenação</span>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="pb-0 pt-0">
        <div class="d-flex justify-space-between mb-2">
          <v-btn v-if="podeCriar" id="feedback.criarBtn" color="primary" dark @click="abrirCriar">
            <v-icon left small>mdi-plus</v-icon>
            Novo feedback
          </v-btn>
          <span v-else></span>

          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            class="ml-2 search-input"
            dense
            hide-details
            label="Pesquisar por aluno ou observação..."
            single-line
            solo
            @keyup.enter="listar"
            @click:append="listar"
          />
        </div>
      </v-col>

      <v-col class="pt-0">
        <v-data-table
          :headers="tableHeaders"
          :items="feedbacks"
          :items-per-page="10"
          :loading="isLoading"
          class="elevation-1"
          no-data-text="Nenhum feedback encontrado"
        >
          <template v-slot:[`item.aluno`]="{ item }">
            {{
              item.matricula && item.matricula.aluno ? item.matricula.aluno.nomecompleto : "- - -"
            }}
          </template>

          <template v-slot:[`item.observacao`]="{ item }">
            <span>{{ truncar(item.observacao) }}</span>
          </template>

          <template v-slot:[`item.criador`]="{ item }">
            {{ item.criador ? item.criador.name : "- - -" }}
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ attrs, on }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  class="ml-1"
                  color="grey darken-1"
                  dark
                  x-small
                  @click="visualizar(item)"
                >
                  <v-icon small>fa fa-eye</v-icon>
                </v-btn>
              </template>
              <span>Visualizar</span>
            </v-tooltip>

            <v-tooltip bottom v-if="podeEditar">
              <template v-slot:activator="{ attrs, on }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  class="ml-1"
                  color="blue-grey lighten-3"
                  x-small
                  @click="abrirEditar(item)"
                >
                  <v-icon small>fa fa-edit</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>

            <v-tooltip bottom color="error" v-if="podeDeletar">
              <template v-slot:activator="{ attrs, on }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  class="ml-1"
                  color="error"
                  x-small
                  @click="deletar(item)"
                >
                  <v-icon small>fa fa-trash</v-icon>
                </v-btn>
              </template>
              <span>Apagar</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <!-- Criar/Editar -->
    <v-dialog v-model="dialog" max-width="640" persistent>
      <ValidationObserver ref="observer">
        <v-card>
          <v-card-title class="primary white--text">
            {{ editando ? "Editar" : "Novo" }} feedback
          </v-card-title>
          <v-card-text class="pt-4">
            <ValidationProvider name="Aluno" rules="required" v-slot="{ errors }">
              <e-autocomplete
                id="feedback.aluno"
                :items="matriculas"
                :item-value="(m) => m.matricula_id"
                :item-text="itemTextAluno"
                :loading="carregandoMatriculas"
                :value="form.matricula_id"
                label="Aluno"
                dense
                :error-messages="errors"
                @change="(v) => (form.matricula_id = v)"
              />
            </ValidationProvider>

            <ValidationProvider
              name="Observação"
              :rules="{ required: true, no_special_chars: true, max_chars: 4000 }"
              v-slot="{ errors }"
            >
              <v-textarea
                id="feedback.observacao"
                ref="observacaoField"
                v-model="form.observacao"
                @input="onObservacaoInput"
                label="Observação"
                outlined
                dense
                rows="6"
                counter="4000"
                maxlength="4000"
                :error-messages="observacaoErro || errors"
              />
            </ValidationProvider>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn text @click="dialog = false">Cancelar</v-btn>
            <v-btn
              id="feedback.salvarBtn"
              color="primary"
              :dark="!salvando"
              :loading="salvando"
              @click="salvar"
            >
              Salvar
            </v-btn>
          </v-card-actions>
        </v-card>
      </ValidationObserver>
    </v-dialog>

    <!-- Visualizar -->
    <v-dialog v-model="dialogView" max-width="640" scrollable>
      <v-card v-if="detalhe">
        <v-card-title class="primary white--text">Feedback</v-card-title>
        <v-card-text class="pt-4">
          <p class="mb-1">
            <strong>Aluno:</strong>
            {{
              detalhe.matricula && detalhe.matricula.aluno
                ? detalhe.matricula.aluno.nomecompleto
                : "- - -"
            }}
          </p>
          <p class="mb-1">
            <strong>Criado por:</strong> {{ detalhe.criador ? detalhe.criador.name : "- - -" }}
          </p>
          <v-divider class="my-2" />
          <p style="white-space: pre-wrap"><strong>Observação:</strong> {{ detalhe.observacao }}</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="amber darken-2" dark @click="dialogView = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </main-template>
</template>

<script>
export default {
  name: "FeedbackCoordenacaoPage",

  data() {
    return {
      isLoading: false,
      search: "",
      feedbacks: [],
      matriculas: [],
      carregandoMatriculas: false,
      dialog: false,
      dialogView: false,
      editando: false,
      salvando: false,
      detalhe: null,
      observacaoErro: "",
      form: this.formPadrao(),
      tableHeaders: [
        { text: "Aluno", value: "aluno" },
        { text: "Observação", value: "observacao", sortable: false },
        { text: "Criado por", value: "criador" },
        { text: "Ações", value: "actions", sortable: false, align: "end" },
      ],
    };
  },

  computed: {
    podeCriar() {
      return this.$can(["feedbackCoordenacao.criar", "feedbackCoordenacao.*"]);
    },
    podeEditar() {
      return this.$can(["feedbackCoordenacao.editar", "feedbackCoordenacao.*"]);
    },
    podeDeletar() {
      return this.$can(["feedbackCoordenacao.deletar", "feedbackCoordenacao.*"]);
    },
  },

  mounted() {
    this.listar();
    this.carregarMatriculas();
  },

  methods: {
    formPadrao() {
      return { id: null, matricula_id: null, observacao: "" };
    },

    truncar(texto) {
      if (!texto) return "";
      return texto.length > 120 ? `${texto.slice(0, 120)}...` : texto;
    },

    onObservacaoInput(valor) {
      const limpo = this.$semEmojisNemEspeciais(valor);
      this.observacaoErro =
        limpo !== (valor || "")
          ? "Não são permitidos emojis ou caracteres especiais inválidos"
          : "";
      this.form.observacao = limpo;
      const field = this.$refs.observacaoField;
      if (field) field.lazyValue = limpo;
    },

    itemTextAluno(m) {
      return `${m.nome}${m.especial ? " (PcD)" : ""} — ${m.codigo || "sem código"}`;
    },

    async listar() {
      this.isLoading = true;
      try {
        this.feedbacks = await this.$services.feedbackCoordenacaoService.listAll(
          this.search || null
        );
      } catch (error) {
        this.$handleError(error);
      }
      this.isLoading = false;
    },

    async carregarMatriculas() {
      if (!this.podeCriar && !this.podeEditar) return;
      this.carregandoMatriculas = true;
      try {
        this.matriculas = await this.$services.feedbackCoordenacaoService.buscarMatriculas(null);
      } catch (error) {
        this.$handleError(error);
      }
      this.carregandoMatriculas = false;
    },

    abrirCriar() {
      this.editando = false;
      this.form = this.formPadrao();
      this.observacaoErro = "";
      this.dialog = true;
      this.$nextTick(() => this.$refs.observer && this.$refs.observer.reset());
    },

    abrirEditar(feedback) {
      this.editando = true;
      this.form = {
        id: feedback.id,
        matricula_id: feedback.matricula_id,
        observacao: feedback.observacao,
      };
      this.observacaoErro = "";
      this.dialog = true;
      this.$nextTick(() => this.$refs.observer && this.$refs.observer.reset());
    },

    visualizar(feedback) {
      this.detalhe = feedback;
      this.dialogView = true;
    },

    async salvar() {
      const valido = await this.$refs.observer.validate();
      if (!valido) return;

      this.salvando = true;
      try {
        const payload = { matricula_id: this.form.matricula_id, observacao: this.form.observacao };
        if (this.editando) {
          await this.$services.feedbackCoordenacaoService.atualizar(this.form.id, payload);
          this.$toast.success("Feedback atualizado com sucesso");
        } else {
          await this.$services.feedbackCoordenacaoService.criar(payload);
          this.$toast.success("Feedback criado com sucesso");
        }
        this.dialog = false;
        await this.listar();
      } catch (error) {
        this.$handleError(error);
      }
      this.salvando = false;
    },

    deletar(feedback) {
      this.$modals.danger({
        buttons: [
          {
            callback: () => this.$modals.close(),
            props: { color: "warning", small: true },
            text: "Cancelar",
          },
          {
            callback: async () => {
              this.$modals.close();
              this.$loaderService.open("Deletando feedback");
              try {
                await this.$services.feedbackCoordenacaoService.deletar(feedback);
                this.$toast.success("Feedback deletado com sucesso");
                await this.listar();
              } catch (error) {
                this.$handleError(error);
              }
              this.$loaderService.close();
            },
            disableIfCodeDoesntMatch: true,
            props: { color: "error", small: true },
            text: "Confirmar",
          },
        ],
        confirmationCode: String(feedback.id),
        confirmationMessage: `Por favor, digite <strong>${feedback.id}</strong> para confirmar`,
        message: "Tem certeza que deseja apagar este feedback?",
        title: "Cuidado!",
      });
    },
  },
};
</script>

<style scoped></style>
